export default "__VITE_ASSET__$XJSDEfd__"